import { API_URL } from "./apiRoutes";
import { FACILITY } from "./useUrlApi";

declare const config: { FACILITIES_URL: any[] };

export const post = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const postMultipart = async (url: string, data: FormData, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    signal,
    body: data,
  });
  return await response.json();
};

export const get = async (url: string, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
  });
  return await response.json();
};

export const del = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "DELETE",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const put = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "PUT",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

// const getFullURL = (url: string) => `${API_URL}${url}`;

const getFullURL = (url: string) => {
  const facility = sessionStorage.getItem(FACILITY);
  if (facility && config) {
    const apiUrl = config.FACILITIES_URL.find((item) => item.value === JSON.parse(facility));
    if (apiUrl) {
      return `${apiUrl.url}${url}`;
    }
  }
  return `${API_URL}${url}`;
};
